import { useState, useEffect } from "react";

/**
 * Hook to manage collapsible state with both automatic and manual control
 * @param shouldCollapse - When true, automatically collapses the section
 * @returns [isOpen, setIsOpen] - Current open state and setter function
 */
export const useAutoCollapse = (shouldCollapse: boolean) => {
  const [manualState, setManualState] = useState<boolean | undefined>(
    undefined
  );

  // Auto-collapse when condition changes, but only if user hasn't manually overridden
  useEffect(() => {
    if (shouldCollapse && manualState === undefined) {
      setManualState(false);
    }
  }, [shouldCollapse, manualState]);

  // Determine final open state: use manual override if set, otherwise use auto logic
  const isOpen = manualState !== undefined ? manualState : !shouldCollapse;

  return [isOpen, setManualState] as const;
};
